/**
 * TrustSection.jsx
 * ---------------------------------------------------------------------------
 * Section 8. Institutional integrity statements. Numbered § notations
 * reinforce the legal register.
 */

import React from "react";
import Section from "../ui/Section.jsx";
import { H2 } from "../ui/Heading.jsx";
import { tokens } from "../../lib/tokens.js";

const STATEMENTS = [
  "Intake does not constitute legal advice.",
  "No fee-sharing structures.",
  "Law firms retain full control.",
  "All data handled confidentially.",
  "Platform operates as an information and analytics layer.",
];

export default function TrustSection() {
  return (
    <Section id="trust" label="VII · Integrity" tone="paper">
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1.4fr",
          gap: 96,
          alignItems: "start",
        }}
      >
        <H2>Built for legal integrity.</H2>
        <div>
          {STATEMENTS.map((t, i) => (
            <div
              key={t}
              style={{
                padding: "28px 0",
                borderTop: `1px solid ${tokens.divider}`,
                borderBottom:
                  i === STATEMENTS.length - 1
                    ? `1px solid ${tokens.divider}`
                    : "none",
                display: "grid",
                gridTemplateColumns: "60px 1fr",
                gap: 20,
                alignItems: "baseline",
              }}
            >
              <span
                style={{
                  fontFamily: "'Cormorant Garamond', serif",
                  fontSize: 18,
                  color: tokens.accent,
                  fontStyle: "italic",
                }}
              >
                § {String(i + 1).padStart(2, "0")}
              </span>
              <span
                style={{
                  fontFamily: "'Cormorant Garamond', serif",
                  fontSize: 22,
                  color: tokens.ink,
                  lineHeight: 1.4,
                  fontWeight: 400,
                }}
              >
                {t}
              </span>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
}
